export const GOOGLE_OAUTH = 'google_oauth'
export const INTRO_LOGIN_BUTTON = 'intro_login_button'
export const UNSUPPORTED_INSTITUTIONS_PLAID = 'unsupported_institutions_plaid'
export const UNSUPPORTED_INSTITUTIONS_POSSIBLE = 'unsupported_institutions_possible'
export const UNSUPPORTED_INSTITUTIONS_ONLINE_BANKS = 'unsupported_institutions_online_banks'
export const HOW_DID_YOU_HEAR_ABOUT_US = 'how_did_you_hear_about_us'
export const INSTANT_DEBIT_ENABLED = 'instant_debit_enabled'
